/** Shared atmosphere presets. A scene is presentation, never game authority. */
export type EnvironmentPreset = 'ocean' | 'space' | 'simple'

export interface EnvironmentSettings {
  readonly preset: EnvironmentPreset
  /** Ambient scenery motion; independent of the game's rules and transitions. */
  readonly motion?: boolean
}

export interface EnvironmentFrame {
  readonly preset: EnvironmentPreset
  /** Presentation seconds. Freeze this value when scenery motion is disabled. */
  readonly time: number
  /** Resolved play surface, separate from scenery and its moving props. */
  readonly bounds?: { readonly center: readonly [number, number, number]; readonly width: number; readonly depth: number }
}

export const ENVIRONMENT_PRESETS: readonly { readonly id: EnvironmentPreset; readonly label: string; readonly description: string }[] = [
  { id: 'ocean', label: 'Ocean', description: 'Quiet turquoise water, little sailboats and a rocky shore.' },
  { id: 'space', label: 'Space', description: 'An orbital table above a distant planet and a field of stars.' },
  { id: 'simple', label: 'Simple', description: 'A calm studio table with soft, neutral light.' },
]
